import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import * as Request from '../tgccRequest';
import { NewCampusUploadFiles } from '../UploadFiles/NewCampusUploadFiles';
import { Message } from '../Components/Message';
import { MajorAccountsHdr } from '../Components/MajorAccountsHdr';

const pageBackground: React.CSSProperties = {
    minHeight: '100vh',
    background: 'linear-gradient(180deg, #f4f7ff 0%, #ffffff 30%)'
};

const pageContent: React.CSSProperties = {
    maxWidth: '1080px',
    margin: '0 auto',
    padding: '96px 16px 40px'
};

const heroCard: React.CSSProperties = {
    background: 'linear-gradient(135deg, #1e2f7b 0%, #3a54b4 75%)',
    color: '#fff',
    borderRadius: '14px',
    padding: '26px 24px',
    boxShadow: '0 16px 32px rgba(58,84,180,0.24)',
    marginBottom: '18px'
};

const surfaceCard: React.CSSProperties = {
    background: '#fff',
    border: '1px solid #e7ebf3',
    borderRadius: '14px',
    boxShadow: '0 10px 22px rgba(34, 51, 84, 0.08)',
    padding: '20px'
};

const sectionTitle: React.CSSProperties = {
    fontFamily: 'BarlowMedium',
    fontSize: '17px',
    marginBottom: '12px',
    color: '#253052'
};

const fieldLabelStyle: React.CSSProperties = {
    fontFamily: 'BarlowMedium',
    fontSize: '14px',
    color: '#253052',
    marginBottom: '6px'
};

const inputStyle: React.CSSProperties = {
    border: '1px solid #cdd7ec',
    height: '42px',
    padding: '0 12px',
    borderRadius: '8px',
    outline: 'none',
    fontFamily: 'BarlowMedium',
    fontSize: '16px',
    color: '#1b2748',
    backgroundColor: '#ffffff'
};

const textAreaStyle: React.CSSProperties = {
    border: '1px solid #cdd7ec',
    width: '100%',
    minHeight: '120px',
    padding: '10px 12px',
    borderRadius: '8px',
    resize: 'vertical',
    fontFamily: 'BarlowMedium',
    fontSize: '16px',
    color: '#1b2748',
    backgroundColor: '#ffffff'
};

class _CsrDtdSamplePrint extends React.Component<Tgcc.BaseProps, any> {
    state = {
        oldJobNumber: '',
        printDimensions: '',
        quantity: '',
        colorNotes: '',
        notes: '',
        uploadedFiles: {},
        proofId: '',
        isWaiting: false,
        error: '',
        finished: false,
        createdProofId: ''
    };

    componentDidMount() {
        const activeProof = this.props.state && this.props.state.ActiveProof;
        const existingProofId = activeProof && activeProof.proofId ? activeProof.proofId : '';
        const existingUploads = activeProof && activeProof.uploadedFiles ? activeProof.uploadedFiles : {};

        if (existingProofId) {
            this.setState({ proofId: existingProofId, uploadedFiles: existingUploads });
            return;
        }

        this.props.dispatch({ type: Tgcc.StateAction.SetActiveProof, payload: new Tgcc.Proof() });
        Request.initProof()
            .then((proofId: string) => {
                this.setProofId(proofId);
            })
            .catch(() => {
                this.setState({ error: 'Failed to initialize request. Please refresh and try again.' });
            });
    }

    setProofId = (id: string) => {
        this.setState({ proofId: id });
        this.props.dispatch({ type: Tgcc.StateAction.UpdateProof, payload: { proofId: id } });
    };

    addUpload = (filename: string, fileUrl: string) => {
        const nextFiles = Object.assign({}, this.state.uploadedFiles, { [filename]: fileUrl });
        this.setState({ uploadedFiles: nextFiles, error: '' });
        this.props.dispatch({ type: Tgcc.StateAction.UpdateProof, payload: { uploadedFiles: nextFiles } });
    };

    removeUpload = (fileUrl: string) => {
        const nextFiles = {};
        Object.keys(this.state.uploadedFiles).forEach((key) => {
            if (this.state.uploadedFiles[key] !== fileUrl) {
                nextFiles[key] = this.state.uploadedFiles[key];
            }
        });
        this.setState({ uploadedFiles: nextFiles });
        this.props.dispatch({ type: Tgcc.StateAction.UpdateProof, payload: { uploadedFiles: nextFiles } });
        if (this.state.proofId) {
            Request.deleteUpload(this.state.proofId, fileUrl);
        }
    };

    submitRequest = () => {
        const login = this.props.state && this.props.state.LoginData;
        const user = this.props.state && this.props.state.UserInfo;

        if (!login) {
            this.setState({ error: 'You must be logged in to submit this request.' });
            return;
        }

        if (!this.state.printDimensions.trim()) {
            this.setState({ error: 'Print dimensions are required.' });
            return;
        }

        if (!this.state.quantity.trim()) {
            this.setState({ error: 'Quantity is required.' });
            return;
        }

        const qty = parseInt(this.state.quantity, 10);
        if (isNaN(qty) || qty <= 0) {
            this.setState({ error: 'Quantity must be a positive number.' });
            return;
        }

        const extraNotes = this.state.notes.trim();
        const oldJob = this.state.oldJobNumber.trim();
        const additionalNotes = [extraNotes, oldJob ? `Older Job Number: ${oldJob}` : '']
            .filter(Boolean)
            .join('\n');

        const payload = {
            proofId: this.state.proofId || undefined,
            printDimensions: this.state.printDimensions.trim(),
            quantity: qty,
            colorNotes: this.state.colorNotes.trim() || undefined,
            additionalNotes: additionalNotes || undefined,
            csrEmail: (user && user.email) ? user.email : login.username,
            uploadedFiles: this.state.uploadedFiles
        };

        this.setState({ isWaiting: true, error: '' });
        Request.createDtdSampleRequest(login, payload)
            .then((createdProof: Tgcc.Proof) => {
                this.setState({ isWaiting: false, finished: true, createdProofId: createdProof.proofId || '' });
            })
            .catch((err: string) => {
                this.setState({ isWaiting: false, error: err || 'Failed to submit request.' });
            });
    };

    whenFinished = () => {
        this.props.dispatch({ type: Tgcc.StateAction.SetActiveProof, payload: new Tgcc.Proof() });
        browserHistory.push(Tgcc.Routes.DashBoard);
    };

    render() {
        if (this.state.finished) {
            return (
                <Message
                    Title="Thank You!"
                    UseTitleScript={true}
                    Message1="Your DTD sample print request has been received."
                    Message2={`Proof Number: ${this.state.createdProofId}`}
                    onContinue={this.whenFinished}
                />
            );
        }

        return (
            <div style={pageBackground}>
                <MajorAccountsHdr />
                <div style={pageContent}>
                    <div style={heroCard}>
                        <div style={{ fontFamily: 'Lulo', fontSize: '22px', marginBottom: '10px' }}>Request a DTD Sample Print</div>
                        <div style={{ fontFamily: 'BarlowLight', fontSize: '16px', lineHeight: '24px', maxWidth: '820px' }}>
                            Add details for dimensions, quantity, artwork source, and color direction. Upload art files if needed,
                            or provide an older job number to pull from.
                        </div>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr', gap: '16px', alignItems: 'start' }}>
                        <div style={surfaceCard}>
                            <div style={sectionTitle}>Request Details</div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
                                <div>
                                    <div style={fieldLabelStyle}>Older Job Number (Optional)</div>
                                    <input
                                        type="text"
                                        placeholder="WO123456"
                                        value={this.state.oldJobNumber}
                                        onChange={(e) => this.setState({ oldJobNumber: e.currentTarget.value })}
                                        style={inputStyle}
                                    />
                                </div>
                                <div>
                                    <div style={fieldLabelStyle}>Print Dimensions *</div>
                                    <input
                                        type="text"
                                        placeholder="11x17"
                                        value={this.state.printDimensions}
                                        onChange={(e) => this.setState({ printDimensions: e.currentTarget.value })}
                                        style={inputStyle}
                                    />
                                </div>
                                <div>
                                    <div style={fieldLabelStyle}>Quantity *</div>
                                    <input
                                        type="number"
                                        min="1"
                                        placeholder="25"
                                        value={this.state.quantity}
                                        onChange={(e) => this.setState({ quantity: e.currentTarget.value })}
                                        style={inputStyle}
                                    />
                                </div>
                            </div>
                            <div style={fieldLabelStyle}>Color Notes</div>
                            <textarea
                                placeholder="Color notes (ink count, PMS, color breakdown, etc.)"
                                value={this.state.colorNotes}
                                onChange={(e) => this.setState({ colorNotes: e.currentTarget.value })}
                                style={{ ...textAreaStyle, minHeight: '100px', marginBottom: '10px' }}
                            />
                            <div style={fieldLabelStyle}>Additional Notes</div>
                            <textarea
                                placeholder="Additional notes"
                                value={this.state.notes}
                                onChange={(e) => this.setState({ notes: e.currentTarget.value })}
                                style={textAreaStyle}
                            />
                        </div>

                        <div style={surfaceCard}>
                            <div style={sectionTitle}>Artwork Upload</div>
                            <div style={{ fontSize: '14px', color: '#5d6784', marginBottom: '10px', lineHeight: '20px' }}>
                                Upload file(s) if available. If not, provide the older job number so the team can pull prior art.
                            </div>
                            {this.props.state && this.props.state.ActiveProof && (
                                <NewCampusUploadFiles
                                    title="Upload Artwork (Optional)"
                                    proofId={this.state.proofId}
                                    uploadedFiles={this.state.uploadedFiles}
                                    addUpload={this.addUpload}
                                    removeUpload={this.removeUpload}
                                    setProofId={this.setProofId}
                                    state={this.props.state}
                                    width="100%"
                                />
                            )}
                        </div>
                    </div>

                    {this.state.error && <div style={{ color: '#b91c1c', fontWeight: 700, textAlign: 'center', marginTop: '16px' }}>{this.state.error}</div>}

                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '18px', marginBottom: '40px' }}>
                        <div style={{ ...Tgcc.Styles.grayButton, backgroundColor: '#8086a0', color: '#fff', margin: 0 }} onClick={() => browserHistory.push(Tgcc.Routes.DashBoard)}>Cancel</div>
                        <div
                            style={{
                                ...Tgcc.Styles.grayButton,
                                backgroundColor: '#1f3db6',
                                margin: 0,
                                boxShadow: '0 8px 20px rgba(31, 61, 182, 0.25)',
                                opacity: this.state.isWaiting ? 0.7 : 1,
                                pointerEvents: this.state.isWaiting ? 'none' as any : 'auto'
                            }}
                            onClick={this.submitRequest}
                        >
                            {this.state.isWaiting ? 'Submitting...' : 'Submit Request'}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: Tgcc.GlobalState) => ({ state });
export const CsrDtdSamplePrint = connect(mapStateToProps)(_CsrDtdSamplePrint);
